module.exports = __webpack_public_path__ + "image26.png";